<template>
  <oie-my-pages-template :title="t('safetySettingsTitle')" :text="t('safetySettingsSubTitle')">
    <div>
      <div class="input-column">
        <validation-observer
          v-slot="{ invalid }"
          tag="form">
          <div class="input-column__container">
            <h2 class="edit-wrapper__title">
              {{ t('loginInformationHeader') }}
            </h2>

            <validation-provider rules="required" slim>
              <template v-slot="{ errors }">
                <oie-base-input-v2
                  v-model="oldPassword"
                  type="password"
                  :label="t('currentPasswordLabel')"
                  :placeholder="t('currentPasswordPlaceholder')"
                  :errors="errors"
                  required></oie-base-input-v2>
              </template>
            </validation-provider>

            <validation-provider vid="pw" rules="required|passwordPolicy" slim>
              <template v-slot="{ errors }">
                <oie-base-input-v2
                  v-model="newPassword"
                  type="password"
                  :label="t('newPasswordLabel')"
                  :placeholder="t('newPasswordLabel')"
                  :description="tStatic('passwordPolicy')"
                  :errors="errors"
                  required></oie-base-input-v2>
              </template>
            </validation-provider>

            <validation-provider rules="required|password:pw" slim>
              <template v-slot="{errors}">
                <oie-base-input-v2
                  v-model="confirmedNewPassword"
                  type="password"
                  :label="t('repeatPasswordLabel')"
                  :placeholder="t('repeatPasswordLabel')"
                  :errors="errors"
                  required></oie-base-input-v2>
              </template>
            </validation-provider>

            <oie-action-wrapper>
              <oie-base-action
                v-element-loader="{ endpoint: 'auth/change' }"
                size="large"
                :disabled="invalid"
                @click="changePassword">
                {{ tStatic('genericSave') }}
              </oie-base-action>
            </oie-action-wrapper>
          </div>
        </validation-observer>
      </div>
    </div>
  </oie-my-pages-template>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      confirmNewPassword: null
    }
  },
  methods: {
    changePassword() {
      httpService.post('auth/change', { newPassword: this.newPassword, oldPassword: this.oldPassword })
    }
  }
}
</script>
